export default __webpack_public_path__ + "static/live-hero-one-left-6fa967b77f6647647daaa9a007b416a2.avif";